import { createFileRoute } from '@tanstack/react-router';

import { ManufacturerManagementPage } from '@/areas/parts/ManufacturerManagement/ManufacturerManagementPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/manufacturers/')({
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ManufacturerManagementPage />;
}
